import { Model, ModelClass } from './Model';
import { useIndex } from './utils/hook-reducers';

export interface DesignExampleType extends ModelClass {
    id: number;
    name: string;
    description: string;
    category_id: number;
    category: any;
    image_id: number;
    image: any;
}

export const DesignExample = Model<DesignExampleType>('DesignExample', { endpoint: 'apparel-design-examples' })`
    id:Int;
    name:String;
    description:String;
    category_id:Int;
    category:Any;
    image_id:Int;
    image:Any;
`;

export const useDesignExampleIndex = (params) => {
    const { items, pagination, isLoading, isError, reload } = useIndex(DesignExample, params);
    return {
        designExamples: items,
        pagination,
        isLoading,
        isError,
        reload,
    };
};
